import React from 'react';
import { Select } from 'antd';
import { GetRequest } from './Ajax';
import { trans as _ } from './i18n';

const { Option } = Select;

export class ADPlanTargetSelect extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            options: []
        };
        this.unmount = false;
        this.adPlanTemplate = [];
        this.adPlanList = [];
        this.adPlanMap = {};
    };

    fetch = ()=>{
        if (!!this.props.product_uid && !!this.props.ad_plan_id) {
            var url = '/control/'+this.props.product_uid+'/adplan_'+this.props.ad_plan_id;
            GetRequest(url)
            .then(resp => {
                this.adPlanList = resp.data.controls;
                this.adPlanTemplate = resp.data.template;
                this.adPlanMap = {};
                for (var i in resp.data.controls) {
                    var entry = resp.data.controls[i];
                    this.adPlanMap[entry.target] = entry;
                }
                this.filter();
                if (!!this.props.onLoaded) {
                    this.props.onLoaded(this.adPlanMap);
                }
            });
        } else {
            this.filter();
        }
    };

    filter = () => {
        var options = [];
        if (this.props.showall==='true') {
            options.push(
                <Option key="adplan_all" value="">
                    {_("All")}
                </Option>
            );
        }
        if (!!this.props.product_uid && !!this.props.ad_plan_id && Array.isArray(this.adPlanTemplate)) {
            var targetTemplate = this.adPlanTemplate.filter(t => t.id==='__adplan_target')[0];
            var targetKeyChoices = {};
            if (!!targetTemplate && !!targetTemplate.rules && Array.isArray(targetTemplate.rules.key_choices)) {
                for (var i in targetTemplate.rules.key_choices) {
                    var kc = targetTemplate.rules.key_choices[i];
                    targetKeyChoices[kc.value] = kc;
                }
            }
            this.adPlanList.filter(entry => {
                return !!targetKeyChoices[entry.key];
            }).forEach(entry => {
                var kc = targetKeyChoices[entry.key];
                var name = kc.name;
                if (!!kc.format) {
                    name = kc.format.replace(/\{\{int_val\}\}/g, ''+entry.int_val).replace(/\{\{float_val\}\}/g, ''+Number.parseFloat(entry.float_val).toFixed(2));
                }
                entry.name = name;
                options.push(
                    <Option key={entry.id} value={entry.target}>
                        {name}
                    </Option>
                );
            });
        }
        if (!this.unmount) {
            this.setState({options: options});
        }
    }

    componentDidMount(){
        this.fetch();
    };

    componentWillUnmount(){
        this.unmount = true;
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.product_uid !== this.props.product_uid) {
            this.fetch();
        }
        if (prevProps.ad_plan_id !== this.props.ad_plan_id) {
            this.fetch();
        }
    }

    handleProductChange(value){
        if (!!this.props.onChange) {
            this.props.onChange(value, this.adPlanMap[value]||{});
        }
    };

    render() {
        return (
            <Select
                {...this.props}
                showSearch
                placeholder={_("Select AD Plan Target")}
                optionFilterProp="children"
                onChange={(v)=>{this.handleProductChange(v)}}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
            >
                {this.state.options}
            </Select>
        );
    };
};
